// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"107":"b1c69f23","291":"7e5d00f4","514":"a3ab9c68"}[chunkId] + ".chunk.css";
};